export class Controller {

    /** @ngInject */
    constructor($q, $state, $timeout, Alert, SmsServices) {
        this.$q = $q;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Alert = Alert;
        this.SmsServices = SmsServices;
    }

    $onInit() {
        this.page = 3;
    }

    purchase() {
        this.finalizeCheckoutPayment('DS').then(() => this.page = 4);
    }

    cancel() {
        this.$q.resolve(this.page === 3 && this.finalizeCheckoutPayment('CA')).then(() => {
            this.Alert('success', 'company.sms-services.paypal-confirmed.payment-cancelled');
            this.$state.go('^');
        });
    }

    /** @private */
    finalizeCheckoutPayment(status) {
        return this.SmsServices
            .finalizeCheckoutPayment(this.$state.params.companyId, this.payment.token, status)
            .catch((error) => {
                if (!error.data) {
                    this.Alert('danger', 'company.sms-services.paypal-confirmed.payment-failed');
                }
                throw error;
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/paypal-confirmed/paypal-confirmed.controller.js